import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function FinalCTASection() {
  return <section className="py-24 bg-rose-600 relative overflow-hidden" data-id="element-80">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-81"></div>
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-black/20" data-id="element-82"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-84">
          <h2 className="text-3xl md:text-5xl font-playfair font-bold text-white mb-6 leading-tight" data-id="element-85">
            Aprendé manicura profesional, empezá a ofrecer tus servicios desde
            casa y generá tus primeros ingresos en pocas semanas.
          </h2>

          <p className="text-rose-100 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-86">
            ¡Accedé ahora al ebook “Empezá y ganá” con todos los bonos
            incluidos!
          </p>

          <Button variant="secondary" size="xl" className="w-full sm:w-auto text-dark hover:text-dark px-10 py-5 shadow-2xl shadow-black/20" data-id="element-87">
            ¡Sí, Quiero Empezar Hoy!
          </Button>
        </motion.div>
      </div>
    </section>;
}